<div id="backorderReports" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportBackOrdersReport()"
    [showClone]=true titleClone="Copy Download Link" (cloneEvent)="copyBackOrdersReportLink()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <div id="btnDownload" class="basic-icon download-icon" placement="bottom" ngbTooltip="Download Excel"
          (click)="exportBackOrdersReport()"></div>
          <div class="basic-icon copy-icon" placement="bottom" ngbTooltip="Copy Download Link" (click)="copyBackOrdersReportLink()"></div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->

      <div style="margin-bottom: 20px;" id="basic-info-wrapper">
        <div class="filter-wrapper">
          <div class="col">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../../images/new_ui/filter.png">
              </div>
              <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="backOrders.length > 0 && !hasEmptyFilterResult">
        <div class="shared-outer-wrapper table-header-allign">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead>
              <tr class="row no-border">
                <th class="col-2">STOCK CODE</th>
                <th class="col">STOCK DESCRIPTION</th>
                <th class="col-1 align-center">LINE QTY</th>
                <th class="col-1 align-center">ALLOC QTY</th>
                <th class="col-1 align-center">B/O QTY</th>
                <th class="col-2 align-center">ETA</th>
              </tr>
              <tr class="row border-bottom">
                <td class="col"></td>
              </tr>
            </thead>
          </table>
          <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
                  *ngIf="showPager"></pagination-controls> -->
        </div>
        <div class="shared-outer-wrapper child-body">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead hidden="true">
              <tr class="row no-border">
                <th class="col-2">STOCK CODE</th>
                <th class="col">STOCK DESCRIPTION</th>
                <th class="col-1 align-center">LINE QTY</th>
                <th class="col-1 align-center">ALLOC QTY</th>
                <th class="col-1 align-center">B/O QTY</th>
                <th class="col-2 align-center">ETA</th>
              </tr>
              <tr class="row border-bottom">
                <td class="col"></td>
              </tr>
            </thead>
            <tbody class="scrollable-table-body">

              <ng-container
                *ngFor="let order of newSortedData | TableFilterMultiple:['orderNo', 'orderSuffix', 'resellerPO', 'orderStatus', 'stockLine.stockCode', 'stockLine.stockDesc', 'stockLine.eta'] : searchField;">
                <tr class="row">
            <tbody class="nested-body">
              <tr class="row no-border no-hover">
                <td class="col">
                  <span class="infoSection-title-bold">Order:&nbsp;</span>
                  <span class="infoSection-content-uppercase">
                    <a [routerLink]="['orderitemdetail/'+ order?.orderNo + order?.orderSuffix]"
                      class="red-bold">{{order?.orderNo}}{{order?.orderSuffix}}</a>
                  </span>
                  <span class="infoSection-title-bold">&nbsp;&nbsp;|&nbsp;&nbsp;Reference:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.resellerPO}}</span>
                  <span class="infoSection-title-bold">&nbsp;&nbsp;|&nbsp;&nbsp;Status:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.orderStatus}}</span>
                </td>
              </tr>
              <ng-container *ngFor="let stockLine of order?.stockLines">
                <tr class="row no-border no-hover">
                  <td class="col-md-2">{{stockLine?.stockCode}}</td>
                  <td class="col-md">{{stockLine?.stockDesc}}</td>
                  <td class="col-md-1 align-center">{{stockLine?.lineQty}}</td>
                  <td class="col-md-1 align-center">{{stockLine?.allocQty}}</td>
                  <td class="col-md-1 align-center">{{stockLine?.backOrderQty}}</td>
                  <td class="col-md-2 align-center">{{stockLine?.eta}}</td>
                </tr>
              </ng-container>
            </tbody>
            </tr>
            </ng-container>


            </tbody>
          </table>
          <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
                  *ngIf="showPager"></pagination-controls> -->
        </div>
      </div>

      <ng-container *ngIf="hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
          <button (click)="filterReset()" class="button button-red button-large">Try again</button>
          <div class="noResult-feedback">Send feedback</div>
        </div>
        <div class="top-divider"></div>
      </ng-container>

      <div class="inner-subBlock-wrapper" *ngIf="loadContent && !backOrders.length && !hasEmptyFilterResult">
        <div class="noData-wrapper">
          <div>
            <img src="../../images/new_ui/no-subscription.png">
          </div>
          <label class="noData-label">
            WE COULDN'T FIND ANY BACK ORDERS
          </label>
          <br />

        </div>
      </div>

    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>
<!-- <div #entry>
    <router-outlet></router-outlet>
  </div> -->
<router-outlet></router-outlet>